import { render } from "./SelectModal.vue?vue&type=template&id=36b71826"
import script from "./SelectModal.vue?vue&type=script&lang=js"
export * from "./SelectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__